import { useState, type FC } from "react";
import { useCanRunAutomation } from "@/queries/automation-queries";
import { Button, type ButtonSize } from "@/components/flexkit/Button";
import { IconPlay } from "central-icons/IconPlay";
import { withGitpodSize } from "@/assets/icons/utils";
import { RunAutomationDialog } from "@/components/automations/RunAutomationDialog";
import type { PlainWorkflow } from "@/queries/automation-queries";

const IconPlayWithSize = withGitpodSize(IconPlay);

type RunAutomationButtonProps = {
    workflow: PlainWorkflow;
    variant?: "primary" | "secondary";
    size?: ButtonSize;
    children?: React.ReactNode;
    disabled?: boolean;
    "data-tracking-id"?: string;
};

export const RunAutomationButton: FC<RunAutomationButtonProps> = ({
    workflow,
    variant = "primary",
    size,
    disabled,
    children,
    "data-tracking-id": dataTrackingId,
}) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const { canRunAutomation } = useCanRunAutomation(workflow.id);

    if (!canRunAutomation) {
        return null;
    }

    return (
        <>
            <Button
                variant={variant}
                size={size}
                LeadingIcon={IconPlayWithSize}
                onClick={() => setIsDialogOpen(true)}
                disabled={disabled}
                data-tracking-id={dataTrackingId}
            >
                {children ?? "Run"}
            </Button>
            <RunAutomationDialog open={isDialogOpen} onOpenChange={setIsDialogOpen} workflow={workflow} />
        </>
    );
};
